import { RequestOptions, requestWith } from './http';

export const API_BASE =
  process.env.NODE_ENV === 'development'
    ? '/api'
    : process.env.REACT_APP_API_URL || 'https://api.reshamtales.com';

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const isJson = Boolean(init.body) && !(init.body instanceof FormData);
  return fetch(`${API_BASE}${path}`, {
    ...init,
    credentials: 'include',
    headers: {
      ...(isJson ? { 'Content-Type': 'application/json' } : {}),
      ...init.headers,
    },
  });
}

/** Customer-facing JSON request; throws `ApiError` on non-2xx responses. */
export function apiRequest<T>(path: string, options?: RequestOptions): Promise<T> {
  return requestWith<T>(apiFetch, path, options);
}
